import { CardContent, Divider } from '@trinity/chat-components/components/presentation/Main/index.js';
import { useGroupTags } from './hooks';
import styles from './style.module.css';
import Editing from './Tags.Editing';
import Readonly from './Tags.Readonly';

export default function Tags() {
  const { editing } = useGroupTags();

  return (
    <>
      <Divider />
      <CardContent className={styles.content}>
        {editing
          ? <Editing />
          : <Readonly />}
      </CardContent>
    </>
  );
}

export { Tags };